import { useSite, usePermissions } from '/src/hooks';
import { RECORDINGS_SITES_QUERY } from '/src/features/recordings/queries';

import { SitePickerBar } from '/src/components/site-picker/index';
import { RecordingAlerts } from '/src/features/_global/components/RecordingAlerts';
import { InstallationBanner } from '/src/components/banners/InstallationBanner';
import { FEATURES } from '/src/features/_global/constants';
import { SourceSelector } from '/src/components/source-selector/source-selector';

export function RecordingsDashboardContentHeader() {
  const permissions = usePermissions();
  const { sites: recordingsSites, loadingSites } = useSite({
    sitesQuery: RECORDINGS_SITES_QUERY,
    dontSelectSite: true,
  });
  const { sites } = useSite({ dontSelectSite: true });
  const canEditSites = permissions.can('create', FEATURES.SITES).allowed;

  return (
    <>
      <SitePickerBar
        Picker={SourceSelector}
        sites={recordingsSites}
        loading={loadingSites}
        showEnableOtherSites={sites.length > recordingsSites.length}
        pageDisplayName="Recordings dashboard"
        addSiteOption={canEditSites}
      />

      <>
        <RecordingAlerts />
        <InstallationBanner />
      </>
    </>
  );
}
